/* eslint-disable global-require */

require('array.prototype.find').shim()
require('array.from').shim()
require('array-includes').shim()

require('intersection-observer')

// Object.assign() is commonly used.
// This polyfill use the native implementation if it's present and isn't buggy.
// Object.assign = require('object-assign')

if (typeof Promise === 'undefined') {
  require('es6-promise').polyfill()
}

Number.isInteger = Number.isInteger || function(value) {
  return typeof value === 'number' &&
    isFinite(value) &&
    Math.floor(value) === value
}



// WEBPACK FOOTER //
// ./config/polyfills.js